// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2yxnp","list":"PatternAutocomplete_list__cQgJ7"};